/* =========================================================
   David Halfon — custom.js (global, update-safe)
   Global price formatting, internal traffic marker,
   footer accordion and newsletter interactions.
   ========================================================= */


/* =========================================================
   1) PRICE FORMATTING — remove trailing ,00 / .00
   ========================================================= */
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname.includes("/cart") || window.location.pathname.includes("/checkout")) return;

    const cleanPriceText = (text) => text.replace(/([.,]00)(?=$|\s|€)/g, "");

    const numberSelectors = [
      ".price-item--regular",
      ".price-item--sale",
      ".price-item--compare",
      ".price__regular .price-item",
      ".price__sale .price-item",
      ".card-information__price",
      ".product__price",
      ".price__compare-item",
    ];

    const updateAllPrices = () => {
      document.querySelectorAll(numberSelectors.join(",")).forEach((el) => {
        if (el.closest(".cart-drawer") || el.closest(".cart-items")) return;
        const originalHTML = el.innerHTML;
        const cleaned = originalHTML.replace(
          /(\d+[.,]\d{2})(?=$|\s|<\/|\&nbsp;|€)/g,
          (match) => cleanPriceText(match)
        );
        if (cleaned !== originalHTML) el.innerHTML = cleaned;
      });
    };

    updateAllPrices();
    const observer = new MutationObserver(() => updateAllPrices());
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();



/* =========================================================
   2) GA4 — INTERNAL traffic marker (update-safe)
   ========================================================= */
(function () {
  var KEY = "dh_internal";
  var TOKEN_ON = "/pages/internal-on-270521";
  var TOKEN_OFF = "/pages/internal-off-270521";
  var COOKIE_ON = "dh_internal=1; path=/; max-age=" + 60 * 60 * 24 * 365;

  function setFlag(on) {
    try {
      if (on) {
        localStorage.setItem(KEY, "1");
        document.cookie = COOKIE_ON;
      } else {
        localStorage.removeItem(KEY);
        document.cookie = "dh_internal=; path=/; max-age=0";
      }
    } catch (e) {}
  }

  function isInternal() {
    try {
      return localStorage.getItem(KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  try {
    var path = window.location.pathname || "";
    if (path === TOKEN_ON) setFlag(true);
    if (path === TOKEN_OFF) setFlag(false);
  } catch (e) {}

  function applyTrafficType(tries) {
    tries = tries || 0;
    if (!isInternal()) return;

    if (typeof window.gtag === "function") {
      window.gtag("set", { traffic_type: "internal" });
      window.gtag("config", "G-E4307231D3", { traffic_type: "internal" });
      return;
    }

    if (tries >= 80) return;
    setTimeout(function () {
      applyTrafficType(tries + 1);
    }, 100);
  }

  applyTrafficType();
})();



(function () {
  const MOBILE_MAX = 749;

  function isMobile() {
    return window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;
  }

  function initFooterAccordions() {
    const footer = document.querySelector('footer.footer, .footer');
    if (!footer) return;

    // Dawn: blocchi del footer spesso sono .footer-block
    const blocks = footer.querySelectorAll('.footer-block');
    if (!blocks.length) return;

    blocks.forEach((block, idx) => {
      // evita doppia inizializzazione
      if (block.dataset.dhAccInit === '1') return;

      // heading tipico Dawn: .footer-block__heading
      const heading = block.querySelector('.footer-block__heading');
      // lista link tipica: ul dentro .footer-block__details-content oppure direttamente ul
      const content =
        block.querySelector('.footer-block__details-content') ||
        block.querySelector('ul');

      if (!heading || !content) return;

      // Se dentro al blocco c’è un form newsletter o altro, saltalo (tu vuoi solo le 3 sezioni menu)
      // Regola: deve contenere una UL con link
      if (!content.querySelector('a')) return;

      block.dataset.dhAccInit = '1';

      // Wrapper accordion (per bordo sopra)
      block.classList.add('dh-footer-acc__wrap');

      // Crea bottone
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dh-footer-acc__btn';
      btn.setAttribute('aria-expanded', isMobile() ? 'false' : 'true');

      const titleSpan = document.createElement('span');
      titleSpan.className = 'dh-footer-acc__title';
      titleSpan.textContent = heading.textContent.trim();

      const chev = document.createElement('span');
      chev.className = 'dh-footer-acc__chev';
      chev.setAttribute('aria-hidden', 'true');

      btn.appendChild(titleSpan);
      btn.appendChild(chev);

      // Panel
      const panel = document.createElement('div');
      panel.className = 'dh-footer-acc__panel';
      const panelId = `dh-footer-panel-${idx}-${Math.random().toString(16).slice(2)}`;
      panel.id = panelId;
      btn.setAttribute('aria-controls', panelId);

      // Sposta il contenuto nel panel
      panel.appendChild(content);

      // Nascondi heading originale
      heading.style.display = 'none';

      // Inserisci bottone + panel (prima del resto)
      // NB: content è già stato spostato nel panel
      block.insertBefore(btn, block.firstChild);
      block.insertBefore(panel, btn.nextSibling);

      // Stato iniziale
      function applyState() {
        const mobile = isMobile();
        if (mobile) {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          panel.style.display = expanded ? 'block' : 'none';
        } else {
          btn.setAttribute('aria-expanded', 'true');
          panel.style.display = 'block';
        }
      }

      applyState();

      // Toggle mobile
      btn.addEventListener('click', () => {
        if (!isMobile()) return;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        panel.style.display = expanded ? 'none' : 'block';
      });

      // Re-apply su resize
      window.addEventListener('resize', () => applyState());
    });
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordions);
  } else {
    initFooterAccordions();
  }
})();




/* ==================================================
  DH — Newsletter popup triggers (clean, scoped)
  - Footer: tap/click input => opens popup (NO keyboard on mobile)
  - Announcement: link #dh-newsletter => opens popup
  - Footer submit: hard block => opens popup (safe)
================================================== */
(function () {
  if (window.__DH_NL_TRIGGERS_INIT__) return;
  window.__DH_NL_TRIGGERS_INIT__ = true;

  function openNL(originEl) {
    const modalEl = document.getElementById("dh-newsletter-modal");
    if (modalEl && !modalEl.hasAttribute("hidden")) return;

    const tryOpen = () => {
      const openFn = window.DHNewsletterModal && window.DHNewsletterModal.open;
      if (typeof openFn === "function") {
        openFn({ originEl });
        return true;
      }
      return false;
    };

    // prova subito
    if (tryOpen()) return;

    // fallback robusto: aspetta fino a ~3.5s (70 * 50ms)
    let tries = 0;
    const t = setInterval(() => {
      tries += 1;
      if (tryOpen() || tries >= 70) clearInterval(t);
    }, 50);
  }

  function isFooterNewsletterEmailInput(el) {
    if (!el || !el.closest) return false;
    if (!el.closest(".footer")) return false;

    return (
      el.matches('.newsletter-form input[type="email"]') ||
      el.matches('.newsletter-form input[name="contact[email]"]')
    );
  }

  /* -----------------------------
     Footer: intercetta PRIMA del focus (fix tastiera mobile)
     NB: usiamo capture=true per “battere” Dawn e Safari/Chrome
  ----------------------------- */
  document.addEventListener(
    "pointerdown",
    function (e) {
      const el = e.target;
      if (!isFooterNewsletterEmailInput(el)) return;

      // blocca focus nativo => niente tastiera
      e.preventDefault();
      e.stopPropagation();
      openNL(el);
    },
    true
  );

  // Desktop: Enter nell'input => popup (no submit footer)
  document.addEventListener(
    "keydown",
    function (e) {
      if (e.key !== "Enter") return;
      const el = e.target;
      if (!isFooterNewsletterEmailInput(el)) return;

      e.preventDefault();
      e.stopPropagation();
      openNL(el);
    },
    true
  );

  /* -----------------------------
     Announcement: SOLO link dedicato
  ----------------------------- */
  document.addEventListener(
    "click",
    function (e) {
      const a = e.target && e.target.closest('a[href="#dh-newsletter"]');
      if (!a) return;

      e.preventDefault();
      e.stopPropagation();
      openNL(a);
    },
    true
  );

  /* -----------------------------
     Footer: blocca submit e usa solo popup (SAFE)
     (lasciato perché tu avevi già il submit nascosto, ma così eviti submit accidentali)
  ----------------------------- */
  if (!window.__DH_NL_FOOTER_BLOCK_INIT__) {
    window.__DH_NL_FOOTER_BLOCK_INIT__ = true;

    document.addEventListener(
      "submit",
      function (e) {
        const form = e.target;
        if (!form || !form.closest) return;

        // Solo nel footer
        if (!form.closest(".footer")) return;

        // Solo form con email (newsletter)
        const email = form.querySelector(
          '.newsletter-form input[type="email"], .newsletter-form input[name="contact[email]"], input[type="email"], input[name="contact[email]"]'
        );
        if (!email) return;

        e.preventDefault();
        e.stopPropagation();
        openNL(email);
      },
      true
    );
  }
})();







(function () {
  function openRestaConnessoMobile() {
    // solo mobile
    if (window.innerWidth > 749) return;

    // trova il bottone "RESTA CONNESSO"
    const btns = document.querySelectorAll('.dh-footer-acc__btn');
    let targetBtn = null;

    btns.forEach((btn) => {
      const title = btn.querySelector('.dh-footer-acc__title');
      if (!title) return;
      
      const txt = title.textContent.trim().toUpperCase();
if (txt === 'RESTA CONNESSO' || txt === 'CONNECT') targetBtn = btn;
    });

    if (!targetBtn) return;

    // trova il panel dal suo aria-controls (più affidabile)
    const panelId = targetBtn.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    // forza stato "aperto" in modo coerente
    targetBtn.setAttribute('aria-expanded', 'true');
    panel.style.display = 'block';
    panel.hidden = false;

    // se esiste un inline style che lo "resetta", lo sovrascriviamo
    // (alcuni script mettono display:none dopo)
  }

  // 1) dopo che la pagina ha caricato TUTTI gli script
  window.addEventListener('load', function () {
    openRestaConnessoMobile();

    // 2) e di nuovo subito dopo (copre il caso in cui un JS lo resetta dopo load)
    setTimeout(openRestaConnessoMobile, 150);
    setTimeout(openRestaConnessoMobile, 400);
  });
})();
